var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"offset":3,"span":18}},[_c('h3',[_vm._v(_vm._s(_vm.user.prenom)+" "+_vm._s(_vm.user.name))]),_c('user-data',{attrs:{"user":_vm.user}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }